const REVIEWS_PREFIX = '@@reviews/';

export const REVIEWS_ACTION_TYPES = {
    FETCH_LIST_REQUEST: `${REVIEWS_PREFIX}FETCH_LIST_REQUEST`,
    FETCH_LIST_SUCCESS: `${REVIEWS_PREFIX}FETCH_LIST_SUCCESS`,
    FETCH_LIST_FAILURE: `${REVIEWS_PREFIX}FETCH_LIST_FAILURE`,
}